<template>
  <div id="scroll">
    <v-row v-for="(chat, index) in isReads" :key="index">
      <v-col cols="12">
        <v-card
          :id="chat.id"
          outlined
          :color="
            parentToBeReplied != chat.id && chat.isMine
              ? 'orange lighten-5'
              : parentToBeReplied != chat.id && !chat.isMine
              ? 'light-blue lighten-5'
              : parentToBeReplied == chat.id
              ? 'pink lighten-4'
              : ''
          "
          max-width="90%"
          width="35%"
          :class="chat.isMine ? 'float-right' : 'float-left'"
          v-if="!showReply && !openEditChat"
        >
          <v-card-text>
            <a
              :href="`#${chat.parentId}`"
              @click="parentToBeReplied = chat.parentId"
            >
              <v-alert
                class="attachment"
                v-if="chat.parentBody"
                border="right"
                :color="
                  chat.isMine ? 'orange lighten-4' : 'light-blue lighten-4'
                "
              >
                {{
                  chat.parentBody.length > 50
                    ? chat.parentBody.slice(0, 50)
                    : chat.parentBody
                }}
              </v-alert>
            </a>

            <div class="d-flex flex-row justify-content-between">
              <div>
                <v-btn
                  icon
                  color="primary"
                  x-small
                  @click="editChat(chat)"
                  v-if="chat.status != 'IsRead'"
                >
                  <v-icon> mdi mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="grey" x-small @click="replyChat(chat)">
                  <v-icon> mdi mdi-reply</v-icon>
                </v-btn>
                <!-- <v-btn icon color="error" x-small @click="deleteChat(chat)">
                  <v-icon> mdi mdi-delete</v-icon>
                </v-btn> -->
              </div>
            </div>
            <div class="my-2">
              <strong>{{ chat.body }}</strong>
            </div>
            <div v-if="chat.attachments && chat.attachments.length > 0">
              <div class="d-flex flex-row flex-wrap">
                <div
                  class="m-3"
                  v-for="(attachment, index) in chat.attachments"
                  :key="index"
                >
                  <v-img
                    :src="attachment.thumbnailFileUrl"
                    width="100"
                    height="100"
                    class="attachment"
                    @click="openImage(attachment.fileUrl)"
                  ></v-img>
                </div>
              </div>
            </div>
            <div v-if="chat.status == 'IsRead'">
              <span>خوانده شده</span>
            </div>
            <div v-if="chat.status == 'Sent'">
              <span>ارسال شده</span>
            </div>
            <div v-if="chat.status == 'IsModified'">
              <span>ویرایش شده</span>
            </div>
          </v-card-text>
        </v-card>

        <BusinessInformationConversationForm
          v-else-if="openEditChat && chat.id == selectedChatForEdit.id"
          @closeChatForm="closeChatForm"
          @getBusinessInformationConversaion="getBusinessInformationConversaion"
          :chatIsEdit="true"
          :selectedChatForEdit="selectedChatForEdit"
        >
        </BusinessInformationConversationForm>
        <BusinessInformationConversationReply
          v-if="showReply && chat.id == selectedToReply.id"
          @closeReplyForm="closeReplyForm"
          @getBusinessInformationConversaion="getBusinessInformationConversaion"
          :showReply="showReply"
          :selectedToReply="selectedToReply"
        >
        </BusinessInformationConversationReply>
      </v-col>
    </v-row>
    <div
      id="unRead"
      v-if="isntRead && isntRead.length"
      style="
        width: 100%;
        height: 10px;
        border-bottom: 1px solid black;
        text-align: center;
      "
      class="my-4"
    >
      <span
        style="font-size: 11px; background-color: #ffffff"
        class="mb-n2 pa-3"
      >
        خوانده نشده
        <!--Padding is optional-->
      </span>
    </div>
    <v-row v-for="(chat, index) in isntRead" :key="index">
      <v-col cols="12">
        <v-card
          :id="chat.id"
          outlined
          :color="
            parentToBeReplied != chat.id && chat.isMine
              ? 'orange lighten-5'
              : parentToBeReplied != chat.id && !chat.isMine
              ? 'light-blue lighten-5'
              : parentToBeReplied == chat.id
              ? 'pink lighten-4'
              : ''
          "
          max-width="90%"
          width="35%"
          :class="[chat.isMine ? 'float-right' : 'float-left']"
          v-if="!showReply && !openEditChat"
        >
          <v-card-text>
            <a
              :href="`#${chat.parentId}`"
              @click="parentToBeReplied = chat.parentId"
            >
              <v-alert
                class="attachment"
                v-if="chat.parentBody"
                border="right"
                color="orange lighten-4"
              >
                {{
                  chat.parentBody && chat.parentBody.length > 50
                    ? chat.parentBody.slice(0, 50)
                    : chat.parentBody
                }}
              </v-alert>
            </a>
            <div class="d-flex flex-row justify-content-between">
              <div>
                <v-btn
                  icon
                  color="primary"
                  x-small
                  @click="editChat(chat)"
                  v-if="chat.status != 'IsRead'"
                >
                  <v-icon> mdi mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="grey" x-small @click="replyChat(chat)">
                  <v-icon> mdi mdi-reply</v-icon>
                </v-btn>
                <!-- <v-btn icon color="error" x-small @click="deleteChat(chat)">
                  <v-icon> mdi mdi-delete</v-icon>
                </v-btn> -->
              </div>
            </div>
            <div class="my-2">
              <strong>{{ chat.body }}</strong>
            </div>
            <div v-if="chat.attachments && chat.attachments.length > 0">
              <div class="d-flex flex-row flex-wrap">
                <div
                  class="m-3"
                  v-for="(attachment, index) in chat.attachments"
                  :key="index"
                >
                  <v-img
                    :src="attachment.thumbnailFileUrl"
                    width="100"
                    height="100"
                    class="attachment"
                    @click="openImage(attachment.fileUrl)"
                  ></v-img>
                </div>
              </div>
            </div>
            <div v-if="chat.status == 'IsRead'">
              <span>خوانده شده</span>
            </div>
            <div v-if="chat.status == 'Sent'">
              <span>ارسال شده</span>
            </div>
            <div v-if="chat.status == 'IsModified'">
              <span>ویرایش شده</span>
            </div>
          </v-card-text>
        </v-card>

        <BusinessInformationConversationForm
          v-else-if="openEditChat && chat.id == selectedChatForEdit.id"
          @closeChatForm="closeChatForm"
          @getBusinessInformationConversaion="getBusinessInformationConversaion"
          :chatIsEdit="true"
          :selectedChatForEdit="selectedChatForEdit"
        >
        </BusinessInformationConversationForm>
        <BusinessInformationConversationReply
          v-if="showReply && chat.id == selectedToReply.id"
          @closeReplyForm="closeReplyForm"
          @getBusinessInformationConversaion="getBusinessInformationConversaion"
          :showReply="showReply"
          :selectedToReply="selectedToReply"
        >
        </BusinessInformationConversationReply>
      </v-col>
    </v-row>
    <div class="mt-3">
      <v-btn color="primary" small @click="newChat()" v-if="!openNewChatForm">
        ثبت پیام جدید
      </v-btn>
      <BusinessInformationConversationForm
        v-else
        :conversationId="conversationId"
        @closeChatForm="closeChatForm"
        @getBusinessInformationConversaion="getBusinessInformationConversaion"
      >
      </BusinessInformationConversationForm>
    </div>
  </div>
</template>

<script>
import BusinessInformationConversationReply from './BusinessInformationConversationReply';
import BusinessInformationConversationForm from './BusinessInformationConversationForm';
import Helper from '@/core/helpers';
import { RepoFactory } from '@/baseRepository/Factory';
const authRepository = () => RepoFactory.get('auth');
const businessInformationConversationRepository = () =>
  RepoFactory.get('businessInformationConversation');

export default {
  components: {
    BusinessInformationConversationReply,
    BusinessInformationConversationForm,
  },
  computed: {
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
  },
  watch: {
    merchantId() {
      if (this.merchantId) {
        this.getBusinessInformationConversaion();
      }
    },
  },
  created() {
    this.getUserDetail();
    if (this.merchantId) {
      this.getBusinessInformationConversaion();
    }
  },

  data() {
    return {
      businessInformationConversationList: null,
      user: null,
      // ObjectTest: { ...ObjectTest },
      isReads: [],
      isntRead: [],
      conversationId: null,
      showReply: false,
      selectedToReply: null,
      parentToBeReplied: null,
      showReply: false,
      openNewChatForm: false,
      openEditChat: false,
      selectedChatForEdit: null,
    };
  },
  methods: {
    getBusinessInformationConversaion() {
      const loader = this.$loading.show();
      let param = {
        objectId: this.merchantId,
        type: 'AdminMerchant',
        topic: 'Merchant',
      };
      businessInformationConversationRepository()
        .getConversation(
          this.contentBaseUrl,
          { MerchantId: this.merchantId },
          param
        )
        .then((res) => {
          this.isReads = [];
          this.businessInformationConversationList = res.data;
          if (this.businessInformationConversationList) {
            this.businessInformationConversationList.forEach((xhat) => {
              if (!xhat.isMine && xhat.status == 'Sent') {
                this.isntRead.push(xhat);
              } else {
                this.isReads.push(xhat);
              }
            });
          }
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
        })
        .finally(() => {
          loader.hide();
          let height = document.getElementById('scroll').scrollHeight;

          // window.onload = function(){
          window.scroll(0, height);
          // }
        });
    },
    getUserDetail() {
      authRepository()
        .getUserDetail(this.$store.getters.authBaseUrl)
        .then((res) => {
          this.user = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    openImage(url) {
      window.open(url, '_blank');
    },
    newChat() {
      this.openNewChatForm = true;
      this.openEditChat = false;
      this.selectedChatForEdit = null;
      this.conversationId = this.businessInformationConversationList.id;
    },
    closeChatForm() {
      this.openNewChatForm = false;
      this.openEditChat = false;
      this.selectedChatForEdit = null;
    },
    closeReplyForm() {
      this.showReply = false;
      this.selectedToReply = null;
    },
    // getBusinessInformationConversaion() {
    //   this.$emit('getBusinessInformationConversaion');
    // },
    editChat(chat) {
      this.openEditChat = true;
      this.selectedChatForEdit = chat;
      this.openNewChatForm = false;
      this.showReply = false;
      this.selectedToReply = null;
    },

    replyChat(item) {
      this.showReply = true;
      this.selectedToReply = item;
      this.openEditChat = false;
      this.openNewChatForm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment {
  cursor: pointer;
}
.reply-color {
  background-color: aquamarine;
}
</style>
